<template>
	<div>
		<el-row class="content">
			<el-table v-loading="loading" :data="list" tooltip-effect="light" :cell-style="cellStyle" :header-cell-style="headCellStyle">
				<!--newView:实体类中放一个表中不存在的字段,在查询数据的时候,推送时间小于一天则为true,否则为false-->
				<el-table-column label="标题" align="left" prop="title" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span style="cursor:pointer" @click="openPage(scope.row)">{{scope.row.title}}</span>
					</template>
				</el-table-column>
				<!--<el-table-column label="操作" align="right">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="historyInfo(scope.row)">取消收藏</el-button>
					</template>
				</el-table-column>-->
			</el-table>
			<pagination
					v-show="total>0"
					:total="total"
					:page.sync="queryParams.pageNum"
					:limit.sync="queryParams.pageSize"
					@pagination="getList"
			/>
		</el-row>
	</div>
</template>

<script>
	import {
		collectList,updateCollect
	} from "@/api/collect/collect";

	export default {
		name: 'tsflfgzc',
		data() {
			return {
				// 遮罩层
				loading: false,
				islogin:false,
				ywFwjgRecid:undefined,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					ywFwjgRecid:undefined,
					pageNum: 1,
					pageSize: 10
				},
			}
		},
		created() {
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			if (ssessionLogin != null) {
				this.islogin = ssessionLogin.islogin;
				this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
				this.queryParams.ywFwjgRecid = this.ywFwjgRecid;
			}
			this.getList();
		},
		methods: {
			resetData(){
				this.total=0;
				this.list=[];
				this.queryParams.pageNum=1;
				this.queryParams.pageSize= 10;
			},
			historyInfo(item){
				/**加入收藏**/
				let uform={};
				uform.ywFwjgRecid = this.ywFwjgRecid;
				uform.busRecid = item.busRecid;
				uform.title = item.title;
				uform.tableName=item.tableName;
				uform.url=item.url;
				updateCollect(uform).then(response =>{
					if (response.code === 200) {
						this.msgSuccess(response.msg);
						this.resetData();
						this.getList();
					} else {
						this.msgError(response.msg);
					}
				});
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getList() {
				this.loading = true;
				let that = this;
				this.queryParams.ywFwjgRecid = this.ywFwjgRecid;
				collectList(this.queryParams).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			qxscOpen(recid){

			},
			//单元格的style的回调方法
			cellStyle({row,column,rowIndex,columnIndex}){
				//columnIndex:是一行一行的从左往右显示
				if(columnIndex === 1){
					return 'padding-left: 100px;';//left是从左往右平移
				}else {
					return ''
				}
			},
			//表头行的style的回调方法    rowIndex:行  columnIndex:列 都是从0开始的
			headCellStyle({row,column,rowIndex,columnIndex}){
				if(columnIndex === 1){
					return 'padding-left: 300px;';
				}else {
					return ''
				}
			},
			openPage(item){
			//此处为了演示，先写死地址
			// 	this.utils.windowOpen('/main/main/flfgzcDetail');
					this.utils.windowOpen(item.url+"/"+item.busRecid);
			}
		}
	}
</script>

<style scoped="scoped">
	.item {
		margin-top: 10px;
		padding-right: 0.625rem;
	}
</style>
